import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated, checkPermission } from '../services/auth';
import { getPathApp } from '../utils/util';

const pathurl = getPathApp(window);
const PrivateRoute = ({ component: Component, validatePermission: permission, validatePermissionArray: permissionsArray, childrenRoute: children, ...rest }) => {

    const validatePermission = (props) => {
        if (isAuthenticated()) {
            if (permissionsArray && permissionsArray.length > 0) {
                var validate = permissionsArray.filter((f => checkPermission(f)));
                if (validate) {
                    return <Component {...props} {...rest} />;
                } else {
                    return <Redirect to={{ pathname: `${pathurl}/unauthorized`, state: { from: props.location } }} />
                }
            }

            if (permission && permission !== '') {
                if (!checkPermission(permission)) {
                    return <Redirect to={{ pathname: `${pathurl}/unauthorized`, state: { from: props.location } }} />
                }
            }
            return <Component {...props} {...rest} />
        } else {
            return <Redirect to={{ pathname: `${pathurl}/login`, state: { from: props.location } }} />
        }
    }

    return (
        <Route
            {...rest}
            render={
                (props) => (validatePermission(props))
            }
        />
    );
};

export default PrivateRoute;
